import * as React from "react";
const SvgFiBrandsDribbble = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-dribbble_svg__a)">
      <path
        fill="#151A2D"
        fillRule="evenodd"
        d="M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12c6.612 0 12-5.375 12-12S18.612 0 12 0m7.926 5.531a10.2 10.2 0 0 1 2.317 6.378c-.338-.065-3.722-.755-7.133-.326-.078-.169-.143-.351-.221-.533a31 31 0 0 0-.677-1.484c3.775-1.536 5.493-3.748 5.714-4.035m-6.508 2.512c-1.679-3.084-3.54-5.61-3.826-6A10.4 10.4 0 0 1 12 1.77c2.603 0 4.985.976 6.794 2.577-.182.26-1.731 2.33-5.376 3.696M7.64 2.733c.273.364 2.095 2.902 3.8 5.922-4.79 1.275-9.02 1.25-9.475 1.25.664-3.176 2.812-5.818 5.675-7.172M1.744 11.7c.442.013 5.414.078 10.529-1.457.3.572.573 1.158.833 1.744-.13.039-.273.078-.404.117-5.284 1.705-8.095 6.365-8.33 6.755a10.23 10.23 0 0 1-2.629-6.846zm12.013 1.992c.026-.013.039-.013.065-.026 1.445 3.735 2.031 6.872 2.187 7.77-1.237.534-2.59.82-4.009.82a10.18 10.18 0 0 1-6.286-2.16c.182-.378 2.264-4.387 8.043-6.404m3.957 6.807c-.104-.625-.651-3.618-1.991-7.302 3.215-.507 6.026.326 6.377.443a10.16 10.16 0 0 1-4.386 6.859"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-dribbble_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsDribbble;
